
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1792 1792"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1477.9 720.5a74 74 0 0173.8 68l.2 6.1v603.1a243.3 243.3 0 01-234 243.2l-9.3.2H483.3a243.3 243.3 0 01-243.2-234l-.2-9.3V794.5a74.1 74.1 0 01147.9-6.1l.2 6.1v603.1a95.2 95.2 0 0088.7 95l6.5.2h825.3a95.2 95.2 0 0095-88.7l.2-6.5V794.5c.2-40.9 33.3-74 74.2-74zM874.8 128.7l6.3-.6 7.4-.1 6.5.6 7.5 1.4 2.9.8c8.3 2.3 16.2 6 23.4 11.3l5.1 4 3.9 3.7L1267 479a74 74 0 01-99.5 109.5l-5.3-4.8-202.7-203v815.9a74 74 0 01-68 73.8l-6.1.2a74 74 0 01-73.8-68l-.2-6.1V380.9L608.7 583.6a74.2 74.2 0 01-99.5 4.8l-5.3-4.8a74.2 74.2 0 01-4.8-99.5l4.8-5.3L832 150.7c2.4-2.5 4.9-4.8 7.6-6.9l4.8-3.4 5-3.1.8-.4a73.6 73.6 0 0124.6-8.2z"}})])
          )
        }
      }
    